<template>
  <div class="wrapper">
    <page-header title="导入单科考试" :paths="['考试列表', '导入成绩']"></page-header>
    <div class="main importSingleExam">
      <div v-if="step == 1" class="steps1">
        <div class="step-item step-1">第1步：创建考试信息</div>
        <div class="step-item step-2">第2步：上传考试数据</div>
      </div>
      <div v-if="step == 2" class="steps2">
        <div class="step-item step-1">第1步：创建考试信息</div>
        <div class="step-item step-2">第2步：上传考试数据</div>
      </div>
      <el-form v-if="step == 1" :model="form" :rules="rules" ref="ruleForm" label-width="130px" class="form-wrapper"
        v-loading="mainLoading">
        <div class="form-left">
          <div class="form-base">
            <el-form-item label="考试名称：" prop="examName">
              <el-input size="small" v-model="form.examName" placeholder="请输入考试名称"></el-input>
            </el-form-item>

            <el-form-item size="small" label="考试类型：" prop="type">
              <el-select v-model="form.type" placeholder="请选择考试类型">
                <el-option label="学前测试" :value="1"></el-option>
                <el-option label="周练" :value="2"></el-option>
                <el-option label="单元练习" :value="3"></el-option>
                <el-option label="月练" :value="4"></el-option>
                <el-option label="期中考试" :value="5"></el-option>
                <el-option label="期末考试" :value="6"></el-option>
                <el-option label="模拟考试" :value="7"></el-option>
                <el-option label="其他" :value="8"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item size="small" label="年级：" prop="grade">
              <el-select v-model="form.grade" @change="_handleGradeChange()" placeholder="请选择年级">
                <el-option v-for="item in gradeList" :key="item.gradeNum" :label="item.gradeName"
                  :value="item.gradeNum"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item size="small" label="学科：" prop="subjectCode">
              <el-select v-model="form.subjectCode" placeholder="请选择学科" :loading="subjectLoading">
                <el-option v-for="item in subjectList" :key="item.dicCode" :label="item.dicName"
                  :value="item.dicCode"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="form-right">
          <div class="form-high">
            <transition name="fade">
              <div>
                <div class="check-box">
                  <div class="check-title">
                    <img src="~images/see.png" width="21" />
                    <span>数据显示设置</span>
                  </div>
                  <el-form-item label="老师查看报表：">
                    <el-radio-group v-model="form.showReport">
                      <el-radio :label="1">允许</el-radio>
                      <el-radio :label="0">不允许</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item label="家长推送微信：">
                    <el-radio-group v-model="form.isOpen" @change="confirmWechat">
                      <el-radio :label="1">允许</el-radio>
                      <el-radio :label="0">不允许</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <transition name="fade">
                    <div class="wechat-radio" v-show="form.isOpen">
                      <el-form-item label="学生答题卷：">
                        <el-radio-group v-model="form.showPaper">
                          <el-radio :label="1">显示</el-radio>
                          <el-radio :label="0">不显示</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="年级平均分、校级和班级排名：">
                        <el-radio-group v-model="form.showGavg">
                          <el-radio :label="1">显示</el-radio>
                          <el-radio :label="0">不显示</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="击败年级比例/进退步：">
                        <el-radio-group v-model="form.showBeat">
                          <el-radio :label="1">显示</el-radio>
                          <el-radio :label="0">不显示</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="成绩所在分数段：">
                        <el-radio-group v-model="form.showCavg">
                          <el-radio :label="1">显示</el-radio>
                          <el-radio :label="0">不显示</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                  </transition>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </el-form>
      <div v-else>
        <div style="text-align: center;padding: 60px 0">
          <a :href="getOssUrl('oss-cn-hangzhou.aliyuncs.com/template/%E5%AF%BC%E5%85%A5%E8%80%83%E8%AF%95%E6%88%90%E7%BB%A9%E6%A8%A1%E6%9D%BF.xls')"
            download="考试数据模板" style="cursor: pointer;" class="temp">
            <img style="vertical-align: top" src="~/images/exam/下载.png" alt />
            下载考试数据模板
          </a>
        </div>
        <div style="text-align: center;margin-bottom: 100px;">
          <div class="input-progress" v-if="progressData > 0">
            <el-progress :text-inside="true" :stroke-width="20" :percentage="progressData" />
          </div>
          <el-upload :headers="headers" ref="importUpload"
            :data="{ schoolId: schoolId, examId: examId, gradeCode: form.grade }" style="display:inline"
            :action="getUploadUrl()" :on-progress="handleProgress" :on-success="handleUploadSuccess"
            :on-change="handleUploadChange" :on-remove="handRemove" accept=".xls, .xlsx" :on-error="handleError"
            :multiple="false">
            <el-button size="small" v-if="!uploadLoading" type="primary" round>上传考试数据</el-button>
          </el-upload>
          <el-button v-if="ifImportError" type="text" size="small" @click="downloadInportError"
            class="download-error-btn">下载错误信息</el-button>
        </div>
      </div>
      <div class="submit">
        <el-button type="primary" v-if="step == 1" size="medium" @click="_createExam" :loading="loading">下一步</el-button>
        <!-- <el-button v-if="uploadSuccess && step == 2" type="primary" size="medium" @click="$router.replace('/exam/single/report/class/basic/' + examId)" :loading="loading">查看报告</el-button> -->
      </div>
    </div>
    <yue-dialog title="导入数据异常" :visible.sync="dialogErrorVisible">
      <div>
        <p style="line-height: 25px;" v-for="(e, i) in errList">{{ i + 1 }}、{{ e }}</p>
      </div>
    </yue-dialog>
  </div>
  <!-- </div> -->
</template>

<script>
import { getExamSubjectList } from '@/api/api'
import { createSingleExam, queryTaskProgress } from '@/api/exam/exam'
import { domain } from '@/config'
import { mapGetters } from 'vuex'
import exam_enum from '@/utils/exam_enum'
import PageHeader from '@/v2/views/components/PageHeader.vue'

export default {
  data () {
    return {
      uploadLoading: false,
      uploadSuccess: false,
      dialogErrorVisible: false,
      errList: [],
      step: 1,
      examId: "",
      schoolId: "",

      headers: {
        Accept: 'application/json',
        token: YJ_SCHOOL_STORAGE.getItem('token')
      },
      loading: false,
      mainLoading: false,
      subjectLoading: false, // 获取学科
      rules: {
        examName: [
          {
            required: true,
            message: "请输入考试名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 48,
            message: "长度不能超过48个字符",
            trigger: "blur"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择考试类型",
            trigger: "blur"
          }
        ],
        grade: [
          {
            required: true,
            message: "请选择年级",
            trigger: "blur"
          }
        ],
        subjectCode: [
          {
            required: true,
            message: "请选择学科",
            trigger: "blur"
          }
        ],
        isHen: [
          {
            required: true,
            message: "请选择阅卷方式",
            trigger: "blur"
          }
        ],
        teamLeaderId: [
          {
            required: true,
            message: "请选择阅卷组长",
            trigger: "blur"
          }
        ]
      },
      subjectId: "", // 当前选择学科的ID

      form: {
        examName: "",
        grade: "",
        hasAdd: 0,
        hasPaper: 0,
        hasTwo: 0,
        importType: 1,
        isHen: 1,
        isMore: 0,
        isOpen: 0,
        objectiveNum: 0,
        paperName: "",
        paperUrl: "",
        pointType: 0,
        schoolId: "",
        showBeat: 0,
        showCavg: 0,
        showGavg: 0,
        showPaper: 0,
        showReport: 0,
        showSum: 0,
        subjectCode: "",
        teamLeaderId: "",
        type: "",
        userId: ""
      },
      subjectList: [],
      teacherList: [],
      fileList: [],

      // 页面初始化时
      fileData: {
        schoolCode: 0,
        type: 1
      },
      oldExamCode: 0,
      domain: domain,
      importErrorUrl: '',
      ifImportError: false,
      progressData: 0,
    };
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      gradeList: "getGradeList"
    })
  },

  mounted () {
    if (this.$route.query.step) {
      this.examId = this.$route.query.examId;
      this.step = this.$route.query.step;
      this.form.grade = this.$route.query.grade;
    }
    this.schoolId = this.userInfo.schoolId;
  },

  methods: {
    getUploadUrl () {
      const newDate = new Date();
      return `${this.domain}/marking-exam-manager/import-exam/import?time=${newDate.getTime()}`
    },
    handleError (err, file, list) {
      this.uploadLoading = false;
      this.ifImportError = false;
      this.$message.error("导入失败");
    },
    handleProgress () {
      this.uploadLoading = true
    },
    handleUploadSuccess (resp, file, list) {
      this.uploadLoading = false;
      if (resp.success) {
        this.checkFileOperateStatus(resp.body);
      } else {
        this.$message.error("上传失败" + resp.message);
        this.submitLoading = false;
      }
    },
    // 轮询模板状态
    async checkFileOperateStatus (id) {
      const resp = await queryTaskProgress(id);
      if (resp.body) {
        if (resp.body.error) {
          // 导入失败
          this.$message.error(resp.body.message);
          this.importErrorUrl = resp.body.error;
          this.ifImportError = true;
          this.submitLoading = false;
          this.importFileList = [];
          this.progressData = 0
        }
        else if (resp.body.completed) {
          // 已结束
          this.progressData = 100
          this.$message.success(resp.body.message);
          this.importErrorUrl = "";
          setTimeout(() => {
            this.$router.back();
          }, 500);
        } else {
          // 处理中
          this.progressData = parseInt(resp.body.step / resp.body.total * 100)
          setTimeout(() => {
            this.checkFileOperateStatus(id);
          }, 2000);
        }
      } else {
        this.submitLoading = false;
      }
    },
    downloadInportError () {
      window.open(this.importErrorUrl);
    },
    handleUploadChange () {
      this.ifImportError = false;
    },

    handRemove (file, fileList) {
      if (fileList.length <= 0) {
        this.ifImportError = false;
      }
    },

    // 年级改变时获取年级下所有学科
    async _handleGradeChange () {
      let params = {
        grade: Number(this.form.grade),
        schoolId: this.schoolId
      };
      this.subjectLoading = true;
      let resp = await getExamSubjectList(params);
      this.subjectLoading = false;

      if (resp.code == 200 && resp.result) {
        this.subjectList = resp.result.main;
      }
    },

    // 创建考试
    _createExam () {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.loading = true;
          let params = JSON.parse(JSON.stringify(this.form));

          // hasAdd 0 hasAdd=0;hasTwo=0
          // hasAdd 1 hasAdd=0;hasTwo=1
          // hasAdd 2 hasAdd=1;hasTwo=0

          if (params.hasAdd === 1) {
            params.hasAdd = 0;
            params.hasTwo = 1;
          }

          if (params.hasAdd === 2) {
            params.hasAdd = 1;
            params.hasTwo = 0;
          }
          params.schoolId = this.schoolId;
          params.userId = this.userInfo.userId;
          params.grade = parseInt(params.grade);
          params.isHen = parseInt(params.isHen);
          params.isOpen = parseInt(params.isOpen);
          params.type = exam_enum.getKeyByValue(params.type, 'examType')
          MtaH5.clickStat("singleimport");
          createSingleExam(params).then(resp => {
            if (resp.success) {
              this.$message({
                message: "创建成功",
                type: "success"
              });
              this.loading = false;
              this.examId = resp.body[0].id;
              this.step = 2;
            } else {
              this.loading = false;
              this.$message({
                message: "创建失败，" + resp.message,
                type: "error"
              });
            }
          });
        } else {
          return false;
        }
      });
    },

    // 试题上传成功
    _handleUploadSuccess (resp, file, fileList) {
      if (resp.code && resp.code !== 200) {
        this.$message({
          message: "上传失败，" + resp.message,
          type: "error"
        });

        this.fileList = [];
      } else {
        if (!resp.url) {
          this.$message({
            message: "上传失败，请重试！",
            type: "error"
          });
          return;
        }

        this.form.hasPaper = 1;
        this.form.paperName = file.name;
        this.form.paperUrl = resp.url;
        this.$message({
          message: "上传成功",
          type: "success"
        });
      }
    },

    // 试题上传失败
    _handleUploadError (err, file, fileList) {
      this.$message({
        message: "上传失败，请重试",
        type: "error"
      });
    },

    confirmWechat (val) {
      let flag = false;
      if (val && !flag) {
        this.$confirm(
          "允许后，考试报告将会推送给家长，是否确认允许？",
          "提示",
          {
            type: "warning"
          }
        )
          .then(() => {
            this.form.isOpen = 1;
            flag = true;
          })
          .catch(() => {
            this.form.isOpen = 0;
            flag = false;
          });
      }
    }
  },
  components: { PageHeader }
};
</script>
<style scoped lang="scss">
.fade-enter-active {
  transition: all 0.3s ease;
}

.fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.header {
  height: 46px;
  line-height: 46px;

  .back {
    display: inline-block;
    cursor: pointer;

    img {
      margin-top: 16px;
      display: inline-block;
    }

    span {
      display: inline-block;
      color: #999999;
      vertical-align: top;
    }

    &:hover span {
      color: $color-theme;
    }
  }
}

.main {
  padding-bottom: 20px;
  min-height: calc(100vh - 170px - 60px);
  background: #fff;
  box-sizing: border-box;
  padding-top: 30px;

  >.steps1 {
    text-align: center;
    font-size: 13px;

    .step-item {
      display: inline-block;
      height: 24px;
      width: 200px;
      border: 1px solid $color-theme;
      line-height: 24px;
      position: relative;
      vertical-align: middle;
    }

    .step-1 {
      background-color: $color-theme;
      color: #fff;
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
    }

    .step-2 {
      border-right: 1px solid $color-theme;
      border-top: 1px solid $color-theme;
      border-bottom: 1px solid $color-theme;
      border-left: none;
      color: #999999;
      ;
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      overflow: hidden;
    }

    .step-1::after {
      content: "";
      position: absolute;
      right: -10px;
      top: 3px;
      height: 18px;
      width: 18px;
      transform: rotate(45deg);
      background: $color-theme;
      border: none;
    }

    .step-2::before {
      content: "";
      position: absolute;
      left: -9px;
      top: 3px;
      height: 18px;
      width: 17px;
      transform: rotate(45deg);
      border-top: 1px solid $color-theme;
      border-right: 1px solid $color-theme;
    }
  }

  >.steps2 {
    text-align: center;
    font-size: 13px;

    .step-item {
      display: inline-block;
      height: 24px;
      width: 200px;
      border: 1px solid $color-theme;
      line-height: 24px;
      position: relative;
    }

    .step-1 {
      border-right: 1px solid $color-theme;
      border-top: 1px solid $color-theme;
      border-bottom: 1px solid $color-theme;
      border-right: none;
      color: #999999;
      ;
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
    }

    .step-2 {
      background-color: $color-theme;
      color: #fff;

      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
    }

    .step-1::after {
      content: "";
      position: absolute;
      right: -9px;
      top: 3px;
      height: 17px;
      width: 17px;
      transform: rotate(45deg);
      border-top: 1px solid $color-theme;
      border-right: 1px solid $color-theme;
      z-index: 1000;
    }

    .step-2::before {
      content: "";
      position: absolute;
      left: -10px;
      top: 3px;
      height: 18px;
      width: 18px;
      transform: rotate(45deg);
      background: #fff;
      border: none;
    }
  }

  >.submit {
    text-align: center;
    margin-top: 40px;

    .el-button {
      padding: 10px 35px;
    }
  }

  .form-wrapper {
    user-select: none;
    padding-top: 20px;
    display: flex;

    .form-left {
      flex: 1;
      padding-right: 70px;

      .form-base {
        float: right;

        .el-form-item {
          margin-bottom: 18px;
        }

        .el-select {
          display: block;
        }

        .el-input {
          width: 322px !important;
        }

        .upload {
          height: 50px;
          line-height: 50px;

          span {
            color: $color-text;
          }

          img {
            float: right;
            margin-top: 12px;
          }
        }
      }
    }

    .form-right {
      flex: 1;
      float: left;

      .form-high {
        .set-switch {
          height: 30px;

          >span {
            display: inline-block;
            line-height: 20px;
            vertical-align: top;
            padding-right: 10px;
          }
        }

        .check-box {
          display: inline-block;
          margin-bottom: 4px;
          padding: 6px 0;
          /*background: #F8F9FB;*/
          min-width: 500px;
          border: 1px solid #d3d3d3;
          border-radius: 4px;

          .check-title {
            padding: 0 5px 0 20px;
            height: 30px;
            line-height: 30px;

            img {
              vertical-align: middle;
            }

            span {
              display: inline-block;
              font-size: 13px;
              padding-left: 5px;
              color: $color-theme;
            }
          }

          .explain {
            float: right;
            margin: 10px 10px 0 0;
            padding: 4px;
            cursor: pointer;
          }

          .el-form-item {
            margin-bottom: 0;
          }

          .el-radio {
            min-width: 70px;
          }

          .wechat-radio {
            padding-left: 30px;

            .el-radio+.el-radio {
              margin-left: 42px;
            }

            ::v-deep .el-form-item__label {
              width: 210px !important;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  .temp {
    color: $color-theme;
  }
}

.input-progress {
  width: 30%;
  margin: auto;
  padding-bottom: 30px;
}

.download-error-btn {
  color: red;
}
</style>

<style>
.importSingleExam .el-upload-list__item {
  max-width: 320px;
  margin: 20px auto;
}
</style>
